import Vue from 'vue'
import Vuex from 'vuex'
import Auth from './modules/auth'
import DialogForms from './modules/dialogForms'
import UserList from "@/store/modules/userList";
// import CatalogSections from './modules/catalogSections'
import QuentityItems from './modules/quantityItems'
import Preloader from './modules/preloader'
import Storages from './modules/storages'
import Articles from './modules/articles'
import Sort from "@/store/modules/sort";
import User from './modules/user';
import ArticlesCategories from './modules/articlesCategories.js'
import Action from './modules/action.js'
import IconDialog from './modules/iconDialog.js';
import TextPage from './modules/textPage.js';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        Auth: Auth,
        DialogForms: DialogForms,
        // CatalogSections,
        QuentityItems,
        Preloader,
        UserList,
        Storages,
        Articles,
        Sort,
        ArticlesCategories,
        User,
        Action,
        IconDialog,
        TextPage,
    },
})
